import AdminAuditLog from '../components/AdminAuditLog';

export default function AdminAuditLogPage() {
  return (
    <div className="p-6">
      <h1 className="font-sans text-lg font-medium mb-5" style={{ color: 'var(--dash-text-primary)' }}>Audit Log</h1>
      <AdminAuditLog limit={100} />
    </div>
  );
}
